import styled from 'styled-components';
import { JoinInput, LoginInput } from '../../components/items/joinInput';
import { useForm } from 'react-hook-form';
import { Button } from '../../components/items/Button';
import { zodResolver } from '@hookform/resolvers/zod';
import { loginSchema } from '../../schema/loginSchema';
import { AlertModal } from '../../components/modal/alert.modal';
import { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { authState } from '../../atoms/authState';
import { useHistory } from 'react-router-dom';
import { loginHandler } from '../../api/login';

interface LoginForm {
  passid: string;
  password: string;
}

const AdminLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setFocus,
  } = useForm({
    resolver: zodResolver(loginSchema),
  });

  // 모달
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const setAuth = useSetRecoilState(authState); // Recoil 상태 업데이트 함수
  const history = useHistory();

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setFocus('passid');
  }, []);

  const onSubmit = async (data: any) => {
    try {
      const response = await loginHandler({
        passid: data.passid,
        password: data.password,
      });

      const { accessToken, refreshToken, expire } = response.token;
      const { userType } = response;
      const expireTime = Date.now() / 1000 + expire;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('expire', String(expireTime));

      // Recoil 상태 업데이트
      if (userType) {
        // userType이 존재하는지 확인
        setAuth({
          isAuthenticated: true,
          userType: userType,
        });
      }

      // 로컬 스토리지에 사용자 유형 저장
      localStorage.setItem(
        'authState',
        JSON.stringify({ isAuthenticated: true, userType }),
      );

      history.push('/admin/member/list');
    } catch (error: any) {
      console.error('로그인 실패:', error.message);
      setModalMessage(
        error.message ||
          '로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.',
      );
      setIsModalOpen(true);
    }
  };

  // 컴포넌트가 마운트될 때 로컬 스토리지에서 auth 상태 복원
  useEffect(() => {
    const storedAuth = localStorage.getItem('authState');
    if (storedAuth) {
      setAuth(JSON.parse(storedAuth));
    }
  }, [setAuth]);
  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="img-box">
          <img src={require('../../assets/img/admin_login.png')} alt="" />
        </div>
        <div className="login">
          <div className="title">Login</div>
          <LoginInput
            name="passid"
            label="아이디"
            placeholder="아이디 입력"
            type="text"
            errors={
              errors.passid?.message ? [errors.passid.message as string] : []
            }
            register={register}
          />
          <LoginInput
            name="password"
            label="비밀번호"
            placeholder="비밀번호 입력"
            type="password"
            btn
            errors={
              errors.password?.message
                ? [errors.password.message as string]
                : []
            }
            register={register}
          />
          <Button title="로그인" type="submit" />
        </div>
      </form>

      {isModalOpen && (
        <AlertModal
          handleConfirmClose={handleModalClose}
          confirmText={modalMessage}
          onClick={handleModalClose}
        />
      )}
    </Container>
  );
};

export default AdminLogin;

// style
const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.homeBgColor};
  form {
    min-height: 50rem;
    min-width: 90rem;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05);
    border-radius: 1.6rem;
    background-color: ${(props) => props.theme.textWhiteColor};
    .img-box {
      display: flex;
    }
    .login {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      padding: 0 7.7rem 0 7.4rem;
      gap: 1.2rem;
      .title {
        font-size: 2.8rem;
        font-weight: 800;
        text-align: center;
        margin-bottom: 1.2rem;
      }
      > * {
        width: 100%;
      }
    }
  }
`;
